const alphaNumericCharacters: string = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

export class StringUtils {
  static randomHexColor = (): string => {
    return '#000000'.replace(/0/g, function () {
      return (~~(Math.random() * 16)).toString(16);
    });
  };
  static randomString(length = 5): string {
    let result = '';

    for (let i = 0; i < length; i++) {
      result += alphaNumericCharacters.charAt(Math.floor(Math.random() * alphaNumericCharacters.length));
    }

    return result;
  }

  /**
   * Locale-independent lexicographic comparator for `Array#sort`. Unlike `String#localeCompare`, the
   * result does not depend on runtime locale settings, so sort order is stable across environments —
   * use it wherever deterministic ordering matters (e.g. graph layout).
   */
  static compareLexicographic = (a: string, b: string): number => (a < b ? -1 : a > b ? 1 : 0);
}
